import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import HomePage from "./component/page/home-page";
import PopupProduct from "./component/pop up not used/pop-product";
import PopupCart from "./component/pop up not used/pop-cart";
import Login from "./component/login/login";
import PopConfirm from "./component/pop up not used/PopConfirm";


/*scroll top*/
/*
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
*/





const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
<PopConfirm/>
      {localStorage.getItem('login')==='true'?<App/>: <Login/>}

<PopupProduct/>

<PopupCart/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
